export const ROUTES_ENUM = {
  DASHBOARD: "dashboard",
  PASSPORT: "passport",
  PORTFOLIO: "portfolio",
  AUDIT_MATERIAL_SALES: "audit-material-sales",
  EXPORTS: "exports",
  ANALYTICS: "analytics",
  MATERIAL_VALUE: "material-value",
  CIRCULARITY: "circularity",
  ENERGY: "energy",
  DATA_QUALITY: "data-quality",
  SOURCE_FILES: "source-files",
  OPERATIONAL_ENERGY: "operational-energy",
  VARIANTS: "variants",
  AI: "ai",
  EEULE: "eeule",
  HOTSPOT_ANALYZER: "hotspot-analyzer",
  PDF_TEMPLATE: "pdf-template",
  EMISSIONS: "emissions",
  MAPPING_EDITOR: "mapping-editor",
  VIEWER: "viewer",
  INVENTORY: "inventory",
  NEW_INVENTORY: "new-inventory",
  TERMS_CONDITIONS: "terms-conditions",
  BUILDINGS: "buildings",
  RULES_EDITOR: "rules-editor",
  COMPONENT_EDITOR: "component-editor",
  PRODUCT_EDITOR: "product-editor",
  ONE: "one",
  REVIT_SETUP: "revit-setup",
  LOG_IN: "log-in",
  ONBOARDING: "onboarding",
  VERIFY: "verify",
  PORTFOLIO_SCREENER: "portfolio-screener",
  PORTFOLIO_ASSETS: "portfolio-assets",
  MANUFACTURER_DASHBOARD: "manufacturer-dashboard",
  ORGANIZATION_PRODUCT_LIST: "product-list",
  ORGANIZATION_EPD_LIST: "epd-list",
  EPD_EDITOR: "epd-editor",
  BUILDING_NO_LICENSE: "building-no-license",
  DGNB18_DASHBOARD: "dgnb18-dashboard",
  DGNB23_DASHBOARD: "dgnb23-dashboard",
  QNG_DASHBOARD: "qng-dashboard",
  LCC: "lcc",
  LEVELS_DASHBOARD: "levels-dashboard",
};
